import { createWidget } from '@funtech-int/rival';

export const notificationsBlockWidget = createWidget<unknown, {}>();
